import apiSlice, { providesList } from "../../app/api/apiSlice";

export const branchesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAwaitingCompanies: builder.query({
			query: () => `/api/companies?status=awaiting&source=register`,
			providesTags: (result) =>
				providesList(result?.companies || null, "AwaitingCompanies"),
		}),
		getCompanies: builder.query({
			query: ({ status, source }) =>
				`/api/companies?status=${status}&source=${source}`,
			providesTags: (result) =>
				providesList(result?.companies || null, "Companies"),
		}),
		getCompanyWithId: builder.query({
			query: (companyId) => `/api/company/${companyId}`,
			providesTags: (result, error, id) => {
				return [
					{ type: "Companies", id: "LIST" },
					{ type: "Companies", id },
				];
			},
		}),
		getCurrentCompanyAdmins: builder.query({
			query: () => `/api/company/admins`,
			providesTags: (result) =>
				providesList(result?.data || null, "CompanyAdmins"),
		}),
		updateCompanyWithId: builder.mutation({
			query: ({ companyId, data }) => ({
				url: `/api/company/${companyId}`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: (result, error, { companyId }) => {
				return [{ type: "Companies", id: companyId }];
			},
		}),
		getCompanyWithIdContactPersons: builder.query({
			query: (companyId) => `/api/company/${companyId}/contactPersons`,
			providesTags: (result, error, id) => {
				return [
					{ type: "CompaniesContactPersons", id: "LIST" },
					{ type: "CompaniesContactPersons", id },
				];
			},
		}),
		updateCompanyWithIdContactPersons: builder.mutation({
			query: ({ companyId, info }) => ({
				url: `/api/company/${companyId}/contactPersons`,
				method: "PUT",
				body: { info },
			}),
			invalidatesTags: (result, error, { companyId }) => {
				return [{ type: "CompaniesContactPersons", id: companyId }];
			},
		}),
		getCompanyWithIdNotes: builder.query({
			query: (companyId) => `/api/company/${companyId}/notes`,
			transformResponse: (response, _meta, _arg) => {
				const sortedData = response.data ? response.data.reverse() : [];
				return { data: sortedData };
			},
			providesTags: (result, error, id) => {
				return [
					{ type: "CompaniesNotes", id: "LIST" },
					{ type: "CompaniesNotes", id },
				];
			},
		}),
		updateCompanyWithIdNotes: builder.mutation({
			query: ({ companyId, note }) => ({
				url: `/api/company/${companyId}/notes`,
				method: "POST",
				body: { note },
			}),
			invalidatesTags: (result, error, { companyId }) => {
				return [{ type: "CompaniesNotes", id: companyId }];
			},
		}),
		getCompanyWithIdPaymentInfo: builder.query({
			query: (companyId) => `/api/company/${companyId}/payments`,
			providesTags: (result, error, id) => {
				return [
					{ type: "CompaniesPaymentInfos", id: "LIST" },
					{ type: "CompaniesPaymentInfos", id },
				];
			},
		}),
		updateCompanyWithIdPaymentInfo: builder.mutation({
			query: ({ companyId, data }) => ({
				url: `/api/company/${companyId}/payments`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: (result, error, { companyId }) => {
				return [
					{ type: "CompaniesPaymentInfos", id: companyId },
					{ type: "Companies", id: "LIST" },
				];
			},
		}),
		acceptCompanyRegistration: builder.mutation({
			query: ({ companyId }) => ({
				url: `/api/company/${companyId}`,
				method: "PUT",
				body: { status: "accepted" },
			}),
			invalidatesTags: [
				{ type: "Companies", id: "LIST" },
				{ type: "AwaitingCompanies", id: "LIST" },
			],
		}),
		removeCompanyRegistration: builder.mutation({
			query: ({ companyId }) => ({
				url: `/api/company/${companyId}`,
				method: "DELETE",
			}),
			invalidatesTags: [
				{ type: "Companies", id: "LIST" },
				{ type: "AwaitingCompanies", id: "LIST" },
			],
		}),
		addCompanyAsContact: builder.mutation({
			query: (data) => ({
				url: `/api/company`,
				method: "POST",
				body: { ...data },
			}),
			invalidatesTags: (result, error, { companyId }) => {
				return [{ type: "Companies", id: companyId }];
			},
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetCompanyWithIdQuery,
	useUpdateCompanyWithIdMutation,
	useGetCompanyWithIdContactPersonsQuery,
	useUpdateCompanyWithIdContactPersonsMutation,
	useGetCompanyWithIdNotesQuery,
	useUpdateCompanyWithIdNotesMutation,
	useGetCompanyWithIdPaymentInfoQuery,
	useUpdateCompanyWithIdPaymentInfoMutation,
	useGetAwaitingCompaniesQuery,
	useGetCompaniesQuery,
	useAcceptCompanyRegistrationMutation,
	useRemoveCompanyRegistrationMutation,
	useAddCompanyAsContactMutation,
	useGetCurrentCompanyAdminsQuery,
} = branchesApiSlice;
